import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'jobOrders'),
  uk: createLocale(uk, 'jobOrders'),
  pl: createLocale(pl, 'jobOrders'),
  ru: createLocale(ru, 'jobOrders'),
  es: createLocale(es, 'jobOrders'),
  uz: createLocale(uz, 'jobOrders'),
  hi: createLocale(hi, 'jobOrders'),
};

export default locales;
